/**
 * @file response-messages.enum.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los enum de los mensajes de respuesta
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-02-26
 * @modified 2026-01-21
 * @author Correcta
 * @modified Sergio Manjón
 * @copyright © Correcta
 * @license Private
 * */

/* eslint-disable no-unused-vars */
export const enum ResponseMessages {
  ERROR = "ERROR",
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  SERVER_ERROR = "SERVER_ERROR",

  INVALID_CREDENTIALS = "INVALID_CREDENTIALS",

  UPDATE_USER_ERROR = "UPDATE_USER_ERROR",

  FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR",
  FILE_DOWNLOAD = "FILE_DOWNLOAD",
  FILE_DOWNLOAD_ERROR = "FILE_DOWNLOAD_ERROR",

  MAX_FILE_SIZE_EXCEEDED = "MAX_FILE_SIZE_EXCEEDED",
}
